import {
  PrimaryLightTextColor,
  PrimaryTextColor,
  boldFont,
  getRelativeFontSize,
  primaryBlueColor,
  primaryWhiteColor,
  regularFont,
} from "../../../../utils/styles";

const SignUpStyles = {
  SignUpWrapper: {},
  leftSection: {
    backgroundColor: primaryBlueColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh",
    padding: "0 10px 0 50px",
    textAlign: "left",
  },
  sectionHeading: {
    fontSize: getRelativeFontSize(22),
    ...boldFont,
    color: primaryWhiteColor,
  },
  sectionSubText: {
    color: primaryWhiteColor,
    ...regularFont,
    fontSize: getRelativeFontSize(2),
  },

  contactInfo: {
    width: "80%",
    textAlign: "left",
    marginLeft: "50px",
    marginTop: "50px",
  },

  listWrapper: {},
  listItemStyle: {
    color: primaryWhiteColor,
    fontSize: getRelativeFontSize(),
    ...regularFont,
  },
  needStyle: {
    color: primaryWhiteColor,
    ...boldFont,
    fontsize: getRelativeFontSize(6),
  },
  needListItems: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: "0",
    width: "fit-content",
  },

  listHeading: {
    color: primaryWhiteColor,
    display: "flex",
    alignItems: "center",
    gap: "10px",
    ...regularFont,
  },
  listInfo: {
    color: primaryWhiteColor,
    fontSize: getRelativeFontSize(2),
    ...boldFont,
  },
  rightSection: {
    display: "flex",
    alignItems: "start",
    justifyContent: "center",
    flexDirection: "column",
    height: "100vh",
    padding: "0 50px 0 50px",
    gap: "20px",
  },
  inputsWrapper: {
    display: "flex",
    gap: "25px",
    flexDirection: "column",
    width: "80%",
  },
  rightSectionHeading: {
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(10),
    ...boldFont,
  },
  ipInfo: {
    fontSize: getRelativeFontSize(-2),
    color: PrimaryTextColor,
    ...regularFont,
  },
  checkboxStyle: {
    "& .MuiFormControlLabel-label": {
      fontSize: getRelativeFontSize(),
    },
  },
  nextButton: {
    width: "150px",
  },
};

export default SignUpStyles;
